<template lang="pug" src="./custom-contact-map.pug"></template>

<script>
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

mapboxgl.accessToken = 'pk.eyJ1IjoibWF0dHJvb3N0ZXIiLCJhIjoiY2pjbWh2c3JnMHZidDMwczNidTBtcGFsbSJ9.valr-XUR2E0pm2Vhajm-Bw'

export default {
  props: ['props'],
  async mounted () {
    setTimeout(() => {
      /* eslint-disable */
      var map = new mapboxgl.Map({
        container: this.$refs.map,
        center: [-122.281, 47.098],
        style: 'mapbox://styles/mapbox/light-v9',
        zoom: 15,
        interactive: false,
        attributionControl: false
      })
      var popup = new mapboxgl.Popup({ offset: 35, closeOnClick: false })
        .setLngLat([-122.281, 47.097])
        .setHTML(`
          <div style='padding: 8px'>
          <h4>Hopke Orthodontics</h4>
          <p>11102 Sunrise Blvd. East, #101<br>
          Puyallup, WA 98374</p>
          <p><a href='https://goo.gl/maps/2D4cvjvNcyP2', target='_blank'><strong>Get Directions</strong></a></p>
          </div>
        `)
        .addTo(map)

      var marker = new mapboxgl.Marker()
        .setLngLat([-122.281, 47.097])
        .addTo(map)
      /* eslint-enable */
    }, 1)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-contact-map/custom-contact-map.vue